export default __webpack_public_path__ + "static/founders-grotesk-light-0e7f8f16794b2ef13d6efbaca18a43c6.eot";